import styled from '@emotion/styled';
import { colors, Text } from '@innovationdepartment/proxima-ui';
import { OpenInNew } from '@mui/icons-material';
import type { BrandProductCellRendererComponentProps } from '../types';

const ContentWrapper = styled.div<{ clickable?: boolean }>`
  display: flex;
  padding: 4px 8px;
  transition: background 0.1s ease;

  ${({ clickable }) => {
    if (!clickable) return '';

    return `
    cursor: pointer;
    &:hover {
      background-color: ${colors.neutral0};
    }
    `;
  }}
`;

const TextWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const SubTextWrapper = styled.div`
  margin-top: 4px;
  display: flex-inline;
  gap: 8px;
`;

const BrandProductsTitle = (props: BrandProductCellRendererComponentProps<'title'>) => {
  const { value, row: product } = props;

  const currentClassification =
    product?.override?.taxonomyClassification ?? product?.taxonomyClassification ?? [];

  const clickable = !!product?.storeUrl;

  const onCellClick = (e: React.MouseEvent) => {
    if (!clickable) return;
    e.stopPropagation();
    window.open(product?.storeUrl ?? '', '_blank');
  };

  return (
    <ContentWrapper onClick={clickable ? onCellClick : undefined} clickable={clickable}>
      <TextWrapper>
        <Text variant="table1Semibold">
          <strong>{value}</strong>
        </Text>
        <SubTextWrapper>
          <Text variant="table1" color="neutral30">
            {currentClassification.slice(0, -1).join(' > ')}&nbsp;&gt;&nbsp;
          </Text>
          <Text variant="table1" color="green40">
            <strong>{currentClassification.at(-1)}</strong>
          </Text>
        </SubTextWrapper>
      </TextWrapper>
      {!!product?.storeUrl && (
        <SubTextWrapper>
          <OpenInNew style={{ color: colors.neutral20, width: 16, height: 16 }} />
        </SubTextWrapper>
      )}
    </ContentWrapper>
  );
};

export default BrandProductsTitle;
